import React from "react";
import BreadCrumb from "../components/BreadCrumb";
import Meta from "../components/Meta";
import { Link } from "react-router-dom";
import { IoArrowBackOutline } from "react-icons/io5";
import blog1 from "../images/blog-1.jpg";
import Container from "../components/Container";

const SingleBlog = () => {
  return (
    <>
      <Meta title={"Dynamic blog name"} />
      <BreadCrumb title="Dynamic blog name" />
      <Container class1="blog-wrapper home-wrapper-2 py-5">
        <div className="row">
          <div className="col-12">
            <div className="single-blog-card">
              <Link to="/blogs" className="d-flex align-items-center">
                <IoArrowBackOutline className="fs-4" />
                Go back to blogs
              </Link>
              <h3 className="title">A beautiful sunday morning renaissance</h3>
              <img src={blog1} alt="blog" className="img-fluid w-100 my-4 " />
              <p>
                You`re only as good as your last collection, which is an
                enormous pressure.I think there is something about luxury.
              </p>
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default SingleBlog;
